
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gQ6y2", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("cK8zQ")).then(()=>parcelRequire('5pFC1'));

});
parcelRegister("jmEuB", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("epnDT", function(module, exports) {
"use strict";
var $a7d5bd68ac71a390$var$cachedBundles = {};
var $a7d5bd68ac71a390$var$cachedPreloads = {};
var $a7d5bd68ac71a390$var$cachedPrefetches = {};
function $a7d5bd68ac71a390$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a7d5bd68ac71a390$var$cachedPreloads;
        case 'prefetch':
            return $a7d5bd68ac71a390$var$cachedPrefetches;
        default:
            return $a7d5bd68ac71a390$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7d5bd68ac71a390$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("by6W6", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("80mPy"))
]).then(()=>parcelRequire('kZlTU'));

});

parcelRegister("iEi71", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("9O12P")),
    (parcelRequire("jmEuB"))($parcel$resolve("cP1Xr"))
]).then(()=>parcelRequire('kx3Em'));

});

parcelRegister("7DiG2", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("bn2wU")).then(()=>parcelRequire('a00pK'));

});

parcelRegister("kSv4F", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("lcXMJ"))
]).then(()=>parcelRequire('akfgw'));

});

parcelRegister("7v0WB", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("eRzc9")).then(()=>parcelRequire('zgFOA'));

});

parcelRegister("dRofv", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("dNaE1")),
    (parcelRequire("jmEuB"))($parcel$resolve("aJ2iz"))
]).then(()=>parcelRequire('7QgcX'));

});

parcelRegister("9DoKb", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("6d87Q")).then(()=>parcelRequire('9e8an'));

});

parcelRegister("5PMi4", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("8ie58"))
]).then(()=>parcelRequire('1PbgQ'));

});

parcelRegister("flsmf", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("9BQct"))
]).then(()=>parcelRequire('cknb6'));

});

parcelRegister("773P4", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("V91w3")).then(()=>parcelRequire('axfU1'));

});

parcelRegister("3r2Db", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("l8pmU")).then(()=>parcelRequire('jT2D4'));

});

parcelRegister("lQkhu", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("gh33N"))
]).then(()=>parcelRequire('8j3FB'));

});

parcelRegister("i78Be", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("d7kIH"))
]).then(()=>parcelRequire('jG5Oy'));

});

parcelRegister("715c5", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("aArfN"))
]).then(()=>parcelRequire('eLHuV'));

});

parcelRegister("jlxNM", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("dNaE1")),
    (parcelRequire("jmEuB"))($parcel$resolve("23zpV"))
]).then(()=>parcelRequire('kXac5'));

});

parcelRegister("m8srM", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("i8DDM")).then(()=>parcelRequire('iixVQ'));

});

parcelRegister("8pHXP", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("ld1m8")).then(()=>parcelRequire('2uJnW'));

});

parcelRegister("3OLMU", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("2yIDL")),
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("eGh4j"))
]).then(()=>parcelRequire('lLA3b'));

});

parcelRegister("lbciO", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("2yIDL")),
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("032eJ"))
]).then(()=>parcelRequire('fUJqE'));

});

parcelRegister("dgO7H", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("2yIDL")),
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("4smq9"))
]).then(()=>parcelRequire('66gVT'));

});

parcelRegister("7ZaIy", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("2yIDL")),
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("9jaBo"))
]).then(()=>parcelRequire('6tM0o'));

});

parcelRegister("jzmBd", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("9O12P")),
    (parcelRequire("jmEuB"))($parcel$resolve("8n64i"))
]).then(()=>parcelRequire('2Efzn'));

});

parcelRegister("4NcbT", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("9O12P")),
    (parcelRequire("jmEuB"))($parcel$resolve("ao1hY"))
]).then(()=>parcelRequire('2RqVU'));

});

parcelRegister("lIM8c", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("9fmP6"))
]).then(()=>parcelRequire('lreLE'));

});

parcelRegister("4ycB8", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("a2HJX"))
]).then(()=>parcelRequire('hBGZx'));

});

parcelRegister("6Jha0", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("7fR0o")).then(()=>parcelRequire('4Iwoi'));

});

parcelRegister("j45ts", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("1Q9Nq"))
]).then(()=>parcelRequire('6ljQu'));

});

parcelRegister("cLWfP", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("dSvR6")).then(()=>parcelRequire('974eL'));

});

parcelRegister("jGXeI", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("lDyMq")).then(()=>parcelRequire('hYhFp'));

});

parcelRegister("dkz0X", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("aTgJp")).then(()=>parcelRequire('8O0s3'));

});

parcelRegister("af1Bn", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("g148w")),
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("1sAkR"))
]).then(()=>parcelRequire('7LBsN'));

});

parcelRegister("7RrE8", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jmEuB"))($parcel$resolve("g148w")),
    (parcelRequire("jmEuB"))($parcel$resolve("4PHEE")),
    (parcelRequire("jmEuB"))($parcel$resolve("8oqvn"))
]).then(()=>parcelRequire('1qPDV'));

});

parcelRegister("dseK2", function(module, exports) {

module.exports = (parcelRequire("jmEuB"))($parcel$resolve("lu6ot")).then(()=>parcelRequire('fBRI3'));

});

var $1389e4a5c515c4c8$exports = {};
$parcel$extendImportMap({
    "cK8zQ": "ccm19.module.0f40ce46.js",
    "80mPy": "asJobs.module.0ef8a29e.js",
    "4PHEE": "asJobs.module.8cb607e4.js",
    "cP1Xr": "iconTilesSlider.module.1dc33120.js",
    "9O12P": "iconTilesSlider.module.4dd13caf.js",
    "bn2wU": "asTopicGlossary.module.cd328b87.js",
    "lcXMJ": "bottomNav.module.11dab24a.js",
    "eRzc9": "clinicFlyout.module.659e2f62.js",
    "aJ2iz": "collapse.module.271312e7.js",
    "dNaE1": "collapse.module.3b00fb26.js",
    "6d87Q": "countUp.module.629f6fc1.js",
    "8ie58": "headerBottomNav.module.bed71927.js",
    "9BQct": "headerSearch.module.1f374f46.js",
    "V91w3": "ceJobSearch.module.375d736e.js",
    "l8pmU": "ceLeistungsspektrum.module.9bec5dfc.js",
    "gh33N": "clinicFinder.module.ea73583b.js",
    "d7kIH": "lightbox.module.3288a5c3.js",
    "aArfN": "mainMenu.module.f421fa0d.js",
    "23zpV": "modal.module.fd26d484.js",
    "i8DDM": "positionButton.module.de293f6f.js",
    "ld1m8": "sharing.module.6a937779.js",
    "eGh4j": "slider1.module.0f6fb68c.js",
    "2yIDL": "slider1.module.cae6c04c.js",
    "032eJ": "slider2.module.885d792d.js",
    "4smq9": "slider3.module.6c74de3c.js",
    "9jaBo": "slider4.module.1700a854.js",
    "8n64i": "slider5.swiper.module.0bcc5f95.js",
    "ao1hY": "slider7.swiper.module.9ad26c04.js",
    "9fmP6": "tabs.module.80742a05.js",
    "a2HJX": "readMoreMarker.module.100b2c23.js",
    "7fR0o": "salaryCalculator.module.6cbda3a5.js",
    "1Q9Nq": "asFalFilebrowser.module.17015c3e.js",
    "dSvR6": "bmiRechner.module.76f9671a.js",
    "lDyMq": "careerFlyout.module.fa591ea7.js",
    "aTgJp": "trainingAuthorisations.module.84f6f848.js",
    "1sAkR": "bannerVideo.module.7e89b90e.js",
    "g148w": "bannerVideo.module.09e9dad9.js",
    "8oqvn": "asVideo.module.48e26572.js",
    "lu6ot": "hideBurgerButtonWithEmptyMenuInDesktop.module.47cfbcb5.js"
});

const $242209826121e47d$var$indexList = [
    window.location.pathname.indexOf("karriere/jobs"),
    window.location.pathname.indexOf("karriere/job"),
    window.location.pathname.indexOf("plugins/as-jobs"),
    window.location.pathname.indexOf("karriere-1/jobs")
];

// =============================================================
// MODULES
// =============================================================
if (document.querySelector("[data-ccm-loader-group]") || document.querySelector(".CCMopen")) (parcelRequire("gQ6y2")).then((module)=>{
    module.init();
});

if (document.getElementById("asjc-url")) (parcelRequire("by6W6")).then((module)=>{
    module.init();
});

if (document.querySelector(".ctype-ce_icon_tile_slider")) (parcelRequire("iEi71")).then((module)=>{
    module.init();
});

if (document.querySelector(".tx-astopicglossary")) (parcelRequire("7DiG2")).then((module)=>{
    module.init();
});

if (document.querySelector('[data-js="banner-video"]')) (parcelRequire("af1Bn")).then((module)=>{
    module.init();
});

if (document.querySelector(".bottom-nav")) (parcelRequire("kSv4F")).then((module)=>{
    module.init();
});

if (document.querySelector(".clinic-flyout")) (parcelRequire("7v0WB")).then((module)=>{
    module.init();
});

if (document.querySelector(".collapse")) (parcelRequire("dRofv")).then((module)=>{
    module.init();
});

if (document.querySelector(".count-up")) (parcelRequire("9DoKb")).then((module)=>{
    module.init();
});

if (document.querySelector(".header__bottom-nav")) (parcelRequire("5PMi4")).then((module)=>{
    module.init();
});

if (document.querySelector(".form-header-search")) (parcelRequire("flsmf")).then((module)=>{
    module.init();
});

if (document.querySelector(".ctype-ce_job_search")) (parcelRequire("773P4")).then((module)=>{
    module.init();
});

if (document.querySelector(".ctype-ce_leistungsspektrum")) (parcelRequire("3r2Db")).then((module)=>{
    module.init();
});

if (document.querySelector(".clinic-finder")) (parcelRequire("lQkhu")).then((module)=>{
    module.init();
});

if (document.querySelector(".lightbox")) (parcelRequire("i78Be")).then((module)=>{
    module.init();
});

if (document.querySelector(".main-nav")) (parcelRequire("715c5")).then((module)=>{
    module.init();
});

if (document.querySelector(".modal")) (parcelRequire("jlxNM")).then((module)=>{
    module.init();
});

if (document.querySelector(".pos-btn")) (parcelRequire("m8srM")).then((module)=>{
    module.init();
});

if (document.querySelector(".btn--share-facebook") || document.querySelector(".btn--share-twitter") || document.querySelector(".btn--share-linkedin") || document.querySelector(".btn--share-xing") || document.querySelector(".btn--share-telegram") || document.querySelector(".btn--share-whatsapp") || document.querySelector(".btn--share-mail")) (parcelRequire("8pHXP")).then((module)=>{
    module.init();
});

if (document.querySelector('[data-js="slider-1"]')) (parcelRequire("3OLMU")).then((module)=>{
    module.init();
});

if (document.querySelector('[data-js="slider-2"]')) (parcelRequire("lbciO")).then((module)=>{
    module.init();
});

if (document.querySelector('[data-js="slider-3"]')) (parcelRequire("dgO7H")).then((module)=>{
    module.init();
});

if (document.querySelector('[data-js="slider-4"]')) (parcelRequire("7ZaIy")).then((module)=>{
    module.init();
});

if (document.querySelector('.swiper-container--5')) (parcelRequire("jzmBd")).then((module)=>{
    module.init();
});

if (document.querySelector('.content-slider--7')) (parcelRequire("4NcbT")).then((module)=>{
    module.init();
});

if (document.querySelector('section [role="tab"]')) (parcelRequire("lIM8c")).then((module)=>{
    module.init();
});

if (document.querySelector(".read-more-marker")) (parcelRequire("4ycB8")).then((module)=>{
    module.init();
});

if (document.querySelector(".ce_salary_calculator")) (parcelRequire("6Jha0")).then((module)=>{
    module.init();
});


if (document.querySelector(".ctype-ce_falfilebrowser_searchwords .searchwords a")) {
    (parcelRequire("i78Be")).then((module)=>{
        module.init();
    });
    (parcelRequire("j45ts")).then((module)=>{
        module.init();
    });
}

if (document.querySelector(".js-player")) (parcelRequire("7RrE8")).then((module)=>{
    module.init();
});

if (document.querySelector(".bmi_content")) (parcelRequire("cLWfP")).then((module)=>{
    module.init();
});

if (document.querySelector(".grid-wrap")) (parcelRequire("jGXeI")).then((module)=>{
    module.init();
});

if (document.querySelector("button.btn.btn--burger-2")) (parcelRequire("dseK2")).then((module)=>{
    module.init();
});

if (document.querySelector(".as-training-authorisations--search")) (parcelRequire("dkz0X")).then((module)=>{
    module.init();
});
// =============================================================
// OTHER
// =============================================================
// if (jobListIndex === -1 && jobOfferIndex === -1) {
//   localStorage.removeItem("prevFlag");
// }
// const preventBack = () => {
//   window.history.forward();
// };
// setTimeout(() => preventBack(), 0);
// window.onunload = function () {
//   null;
// };
// =============================================================
let $242209826121e47d$var$attempts = 0;
const $242209826121e47d$var$whenComplete = ()=>{
    if (++$242209826121e47d$var$attempts > 30) return;
    $242209826121e47d$var$attempts += 1;
    if (document.readyState === "complete") {
        let hasValueAboveMinusOne = false;
        for(let i = 0; i < $242209826121e47d$var$indexList.length; i++)if ($242209826121e47d$var$indexList[i] > -1) {
            hasValueAboveMinusOne = true;
            break;
        }
        if (hasValueAboveMinusOne) localStorage.setItem("prevFlag", "true");
        else localStorage.removeItem("prevFlag");
    } else setTimeout(()=>$242209826121e47d$var$whenComplete(), 400);
};
$242209826121e47d$var$whenComplete(); // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (styleAttempts > 30) return;
 //   styleAttempts += 1;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(function () {
 //       stylesComplete();
 //     }, 300);
 //   }
 // };
 // stylesComplete();


//# sourceMappingURL=as-modern.js.map
